import { CCCLinkList, CCCLinkListState } from "../components/link-list";
import LinkLister from "../core/common/LinkLister";
import CategoryModel from "../models/CategoryModel";

import { selectAnchor } from "../core/utilities";
import { CustomElement } from "../core/CustomElement";

export default class TipsController extends LinkLister {
  public $panel: CustomElement = null;

  async init(anchor: string): Promise<void> {
    try {
      this.$panel = <CustomElement>selectAnchor(anchor);
      if (this.$panel) {
        this.customElement = <CCCLinkList>(
          selectAnchor("ccc-link-list", this.$panel)
        );
        await this.loadTips();
      }
    } catch (e) {
      console.error(e);
    }
  }

  async loadTips(): Promise<void> {
    const tipTag = await CategoryModel.lookupForCurrentTipTag();
    const opts: CCCLinkListState = {
      links: [],
      emptyListMsg: "No tips found",
    };

    if (tipTag) {
      const links = await CategoryModel.getTipsForCurrentCategory(6);
      opts.links = links.slice(0, 5);
      if (links.length > 5) {
        opts.moreLink =
          process.env.VANILLA_COMMUNITY_URL +
          "discussions/tagged/" +
          tipTag.urlCode;
      }
      opts.createButton = {
        href:
          window.location.href.replace("categories", "post/discussion") +
          `?tag=${tipTag.urlCode}`,
        text: "Create Tip",
      };
      this.setData(opts);
    } else {
      this.$panel.hide();
    }
  }
}
